
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './equipconfig-add-or-update'
	// import Template from "@/template.vue";
	import ShowFile from './contract-showfile'
	import ConInfo from './config-info'
	// import fa from "element-ui/src/locale/lang/fa";
	@Component({
		name: 'contractinfo',
		components:{
			AddOrUpdate,
			ShowFile,
			ConInfo
		}
	})
	export default class contractinfo extends Vue {
		customerVisible=false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		activeNames=[];
		showbmxxVisible: boolean = false;
		customerList=[]
		showfileVisible=false
		showInfoVisible=false

		searchForm= {
			name:''
		}
		startTime=[]
		endTime=[]
		amount=['','']
		contractList=[]
		loading: boolean = false;
		dataListSelections=[];
		sjbm=[]
		selectBm=''
		created() {
			this.searchData();

		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}

		preview(row){
			// var viewUrl = this.$request.defaults.baseURL+'/bjba/contract/preview/'+id+'?type=1&access_token='+this.$store.getters.token
			// window.open(viewUrl)
			this.showfileVisible = true
			this.$nextTick(() => {
				this.$refs.showfile.init(row)
			})
		}
		showInfo(row){

			this.showInfoVisible = true
			this.$nextTick(() => {
				this.$refs.showinfo.init(row.id)
			})
		}
		download(id) {
			var downUrl = this.$request.defaults.baseURL+'/bjba/contract/download/'+id+'?type=1&access_token='+this.$store.getters.token
			window.location.href = downUrl
		}
		changeIndex() {
			this.currentNo = 1
		}
		searchData() {
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.loading = true;
			this.$request({
					url: '/bjba/equip/config/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.contractList = data.data.data;
						this.pageTotal = data.data.count
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		addOrUpdate(val: any) {

			this.customerVisible = true
			this.$nextTick(() => {
				this.$refs.customer.init(val)
			})

		}

		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/equip/config/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
	}
